import { useCallback, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PageLoadedContext from './PageLoadedContext';

export default function usePageLoaded(): [boolean, () => void] {
  const ctx = useContext(PageLoadedContext);
  const location = useLocation();
  const isLoaded = useMemo(() => ctx?.pagesLoaded.includes(location.pathname), [ctx?.pagesLoaded, location.pathname]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setLoaded = useCallback(() => { ctx?.setPageLoaded(location.pathname); }, [location.pathname]);
  return [isLoaded, setLoaded];
}
